var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    fillRule: "evenodd",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "0.5em",
    height: "0.5em",
    viewBox: "0 0 36 43.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document",
    fill: "none",
    stroke: "black",
    fontFamily: "Times New Roman",
    fontSize: 16,
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Spread",
    transform: "translate(0 -43.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.932,7.674 L 29.932,10.735 L 33.016,10.735 L 33.015,30.495 L 24.389,30.701 C 23.579,30.72 22.933,31.383 22.933,32.193 L 22.933,40.439 L 10.509,40.439 L 10.509,37.101 L 7.525,37.101 L 7.525,41.972 C 7.525,42.813 8.196,43.5 9.017,43.5 L 24.313,43.5 C 24.704,43.5 25.092,43.334 25.371,43.04 L 35.562,32.551 C 35.837,32.265 36,31.876 36,31.478 L 36,9.202 C 36,8.357 35.33,7.674 34.508,7.674 L 29.932,7.674 Z M 30.391,33.542 L 25.917,38.149 L 25.917,33.649 L 30.391,33.542 Z",
    stroke: "none",
    fill: "#666666",
    fillRule: "evenodd",
    strokeWidth: 0.5,
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403193612775
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.987,15.023 C 4.987,15.846 5.655,16.515 6.479,16.515 L 22.538,16.515 C 23.361,16.515 24.03,15.846 24.03,15.023 C 24.03,14.199 23.361,13.531 22.538,13.531 L 6.479,13.531 C 5.655,13.531 4.987,14.199 4.987,15.023 Z",
    strokeWidth: 0.5,
    stroke: "none",
    fill: "#666666",
    fillRule: "evenodd",
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403193612775
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,1.492 L 0,34.258 C 0,35.081 0.668,35.75 1.492,35.75 L 16.787,35.75 C 17.19,35.75 17.576,35.586 17.857,35.297 L 28.053,24.8 C 28.323,24.522 28.475,24.149 28.475,23.761 L 28.475,1.492 C 28.475,0.668 27.806,0 26.983,0 L 1.492,0 C 0.668,0 0,0.668 0,1.492 Z M 25.491,2.984 L 25.491,22.783 L 16.86,22.988 C 16.051,23.007 15.404,23.67 15.404,24.48 L 15.404,32.766 L 2.984,32.766 L 2.984,2.984 L 25.491,2.984 Z M 22.892,25.83 L 18.388,30.468 L 18.388,25.937 L 22.892,25.83 Z",
    stroke: "none",
    fill: "#666666",
    fillRule: "evenodd",
    strokeWidth: 0.5,
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403193612775
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.991,8.527 C 4.991,9.35 5.659,10.019 6.483,10.019 L 22.546,10.019 C 23.369,10.019 24.038,9.35 24.038,8.527 C 24.038,7.703 23.369,7.035 22.546,7.035 L 6.483,7.035 C 5.659,7.035 4.991,7.703 4.991,8.527 Z",
    strokeWidth: 0.5,
    stroke: "none",
    fill: "#666666",
    fillRule: "evenodd",
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403193612775
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocuments);
export default __webpack_public_path__ + "static/media/icon-documents.99baee706468bff29f33b8645732a15f.svg";
export { ForwardRef as ReactComponent };